import React from 'react'
import Box from '@mui/material/Box';
// import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
// import NewspaperIcon from '@mui/icons-material/Newspaper';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
// import FiberManualRecordRoundedIcon from '@mui/icons-material/FiberManualRecordRounded';
import { convertDate, timeSince } from '../../../helpers/time';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
// import { getRandomStr } from '../../../helpers';

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.primary.main,
    // color: 'rgba(0, 0, 0, 0.87)',
    color: '#fff',
    boxShadow: theme.shadows[1],
    fontSize: 12,
    fontWeight: 600,
  },
}));

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? 'rgb(10, 25, 41)' : '#fff',
  ...theme.typography.body2,
  height: '100%',
  color: theme.palette.text.secondary,
  // boxShadow: theme.palette.mode === 'dark' ? 0 : '0 0.5px 1px rgb(132 135 154 / 20%), 0 2px 3px rgb(132 135 154 / 10%)',
  boxShadow: theme.palette.mode === 'dark' ? 0 : '0 0.5px 1px rgb(255 255 255 / 20%), 0 2px 3px rgb(255 255 255 / 10%)',
  border: theme.palette.mode === 'dark' ? '1px solid rgb(19, 47, 76)' : '1px solid #eae9ee',
  borderRadius: '7px',
  '& .Item-Head': {
    background: '#fbfbfc',
    borderBottom: '1px solid #eae9ee',
    marginBottom: 0,
    padding: theme.spacing(1.5, 2, 1.5, 2),
    borderRadius: '7px 7px 0 0',
    '& a': {
      textDecoration: 'none',
    },
    '& .option-title': {
      fontWeight: 600,
      color: '#13113c',
      fontSize: '.875rem',
    }
  },
  '& .Item-Body': {
    padding: theme.spacing(1),
  }
}));

const RecentNews = ({ news, title, columns, description }) => {
  return (
    <>
      {news &&
        <Item component="div" className="col-md-12">
          <Box component="div" className="row sum-r recent-news">
            <Box component="div" className="s-card">
              <Box className="Item-Head" >
                <Typography className="option-title" component="p" sx={{ textAlign: 'left', mb: .2 }} >{(title || `Recent News`)}</Typography>
                {description && <Typography variant="body2" component="div" sx={{ fontSize: '.75rem !important', textAlign: 'left', }} >{description}</Typography>}
              </Box>
              <Box component="div" className="news-widget">
                {news && news.map((d) => {
                  let n = (d.title).lastIndexOf('-');
                  let source = (d.title).substring(n + 1);
                  return (
                    <Stack
                      // direction={{ md: "row", xs: 'column' }}
                      direction={'column'}
                      key={d.link}
                      sx={{
                        py: .5, px: 1,
                        // alignItems: { md: 'center', xs: 'end', sm: 'start' },
                        width: '100%', borderBottom: '1px solid #eae9ee',
                        '&:nth-child(even)': { background: '#fbfbfc' },
                        '&:last-child': { borderBottom: 0, borderRadius: '0 0 7px 7px' },
                        '&:hover .date, &:hover .time': { display: 'none' },
                        '&:hover .since': { display: 'inline' },
                        '& .date, .time': { display: 'inline' },
                        '& .since': { display: 'none' },
                      }}>
                      <Chip label={
                        <React.Fragment>
                          <span className="source">{d.source}</span>
                          {timeSince(new Date(d.pubDate))?.includes('days') ?
                            <>
                              <span className="-date">{` • `}{convertDate(d.pubDate, "dd MMM yyyy")}</span>
                              <span className="-time">{` • `}{convertDate(d.pubDate, "hh:mm aaaaa'm'")}</span>
                            </>
                            : <span className="-since">{` • `}{timeSince(new Date(d.pubDate))} ago</span>}
                        </React.Fragment>}
                        size="small"
                        sx={{ '& .MuiChip-label': { px: 0 }, bgcolor: 'transparent', px: 1, m: 0, fontSize: '.7rem', color: '#434166c7', height: '16px', justifyContent: 'left' }} />
                      <Box component="div" sx={{ px: 1, py: 0 }}>
                        <Typography component="div" sx={{
                          fontSize: '.875rem', textAlign: 'left',
                          '& a': {
                            color: 'text.link', textDecoration: 'none',
                            fontSize: '.87rem', mr: { md: 0, xs: 1, sm: 1 },
                            display: '-webkit-box', WebkitLineClamp: 1, WebkitBoxOrient: 'vertical', overflow: 'hidden', textOverflow: 'ellipsis',
                          },
                          '& a:hover': { textDecoration: 'underline' }
                        }} className="news-title">
                          <a
                            href={d.link}
                            target='_blank'
                            rel="noreferrer noopener"
                            dangerouslySetInnerHTML={{ __html: (d.title).replace(` -${source}`, '') }}
                          />
                        </Typography>
                      </Box>
                    </Stack>)
                })}
              </Box>
            </Box>
          </Box>
        </Item >}
    </>
  )
}

export default (RecentNews)


// import React from 'react'
// import Box from '@mui/material/Box';
// import Divider from '@mui/material/Divider';
// import Typography from '@mui/material/Typography';
// import Chip from '@mui/material/Chip';
// // import NewspaperIcon from '@mui/icons-material/Newspaper';
// import Paper from '@mui/material/Paper';
// import Stack from '@mui/material/Stack';
// import { styled } from '@mui/material/styles';
// // import FiberManualRecordRoundedIcon from '@mui/icons-material/FiberManualRecordRounded';
// import { convertDate, timeSince } from '../../../helpers/time';
// import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
// import { getRandomStr } from '../../../helpers';

// const LightTooltip = styled(({ className, ...props }) => (
//   <Tooltip {...props} classes={{ popper: className }} />
// ))(({ theme }) => ({
//   [`& .${tooltipClasses.tooltip}`]: {
//     backgroundColor: theme.palette.primary.main,
//     // color: 'rgba(0, 0, 0, 0.87)',
//     color: '#fff',
//     boxShadow: theme.shadows[1],
//     fontSize: 12,
//     fontWeight: 600,
//   },
// }));

// const Item = styled(Paper)(({ theme }) => ({
//   backgroundColor: theme.palette.mode === 'dark' ? 'rgb(10, 25, 41)' : '#fff',
//   ...theme.typography.body2,
//   height: '100%',
//   color: theme.palette.text.secondary,
//   boxShadow: theme.palette.mode === 'dark' ? 0 : '0 0.5px 1px rgb(132 135 154 / 20%), 0 2px 3px rgb(132 135 154 / 10%)',
//   border: theme.palette.mode === 'dark' ? '1px solid rgb(19, 47, 76)' : 0,
//   '& .Item-Head': {
//     background: '#fbfbfc',
//     borderBottom: '1px solid #eae9ee',
//     marginBottom: 0,
//     padding: theme.spacing(1, 2),
//     borderRadius: '4px 4px 0 0',
//     '& a': {
//       textDecoration: 'none',
//     },
//     '& .option-title': {
//       fontWeight: 600,
//       color: '#13113c',
//       fontSize: '.875rem',
//     }
//   },
//   '& .Item-Body': {
//     padding: theme.spacing(1),
//   }
// }));

// const RecentNews = ({ news, title, columns, description }) => {
//   return (
//     <>
//       {news &&
//         <Item component="div" className="col-md-12">
//           <Box component="div" className="row sum-r recent-news">
//             <Box component="div" className="s-card">
//               <Box
//                 className="Item-Head"
//                 sx={{ mb: 0.5, px: 0.5, }}
//               >
//                 <Typography className="option-title" component="h4" sx={{ textAlign: 'left', mb: .3 }} >{(title || `Recent News`)}</Typography>
//                 {description && <Typography variant="body2" component="div" sx={{ fontSize: '.75rem !important', textAlign: 'left', mb: 1.5, }} >{description}</Typography>}
//               </Box>
//               <Box component="div" className="news-widget">
//                 {news && news.map((d) => {
//                   let n = (d.title).lastIndexOf('-');
//                   let source = (d.title).substring(n + 1);
//                   return (
//                     <LightTooltip key={getRandomStr(3)} followCursor title={`${d.source}, ${convertDate(d.pubDate, "dd MMM yyyy")}, ${convertDate(d.pubDate, "hh:mm aaaaa'm'")}`} disableInteractive placement="top-end">
//                       <Stack direction={{ md: "row", xs: 'column' }} key={d.link} sx={{ alignItems: { md: 'center', xs: 'end', sm: 'start' }, width: '100%', borderBottom: '1px solid #eae9ee', '&:nth-child(even)': { background: '#f7f8fa' } }}>
//                         <Box component="div" sx={{ display: { xs: 'none', md: 'block' }, px: 1, py: .5, '& .date-time': { display: 'none' }, '&:hover': { '& .date-time': { display: 'block' }, '& .day-ago': { display: 'none' } }, mt: 0.3, width: { md: '18%' } }}>
//                           <Typography component="div" sx={{ fontSize: '.875rem', textAlign: 'left', mt: 0, '& .MuiChip-root:hover': { bgcolor: 'transparent' } }} className="mb-0">
//                             <Chip label={d.source} sx={{ '& .MuiChip-label': { px: 0 }, bgcolor: 'transparent', p: 0, m: 0, fontSize: '.875rem', borderRadius: '5px', height: '1.5rem', color: 'text.description' }} />
//                           </Typography>
//                         </Box>
//                         <Box component="div" sx={{ width: { md: '82%' }, px: 1, py: .5 }}>
//                           <Typography component="div" sx={{ fontSize: '.875rem', textAlign: 'left', '& a': { color: 'text.link', textDecoration: 'none', fontSize: '.875rem', mr: { md: 0, xs: 1, sm: 1 } }, '& a:hover': { textDecoration: 'underline' } }} className="news-title" >
//                             <a
//                               href={d.link}
//                               target='_blank'
//                               rel="noreferrer noopener"
//                               dangerouslySetInnerHTML={{ __html: (d.title).replace(` -${source}`, '.') }}
//                             />
//                             <Chip label={`${d.source},`} sx={{ display: { md: 'none' }, '& .MuiChip-label': { px: 0 }, bgcolor: 'transparent', p: 0, mx: 0, fontSize: '.875rem', borderRadius: '5px', height: '1.5rem', color: 'text.description' }} />
//                             <Typography variant="body1" className="day-ago" sx={{
//                               fontSize: '.875rem', textAlign: 'left', mt: 0, ml: .7, '& .MuiChip-root:hover': { bgcolor: 'transparent' }, whiteSpace: 'nowrap',
//                               // color: '#6E6E8C'
//                               color: 'text.description'
//                             }}>
//                               {timeSince(new Date(d.pubDate))} ago
//                             </Typography>
//                           </Typography>
//                         </Box>
//                       </Stack>
//                     </LightTooltip>)
//                 }
//                 )}
//               </Box>
//             </Box>
//           </Box>
//         </Item>}
//     </>
//   )
// }

// export default (RecentNews)
